import React, {Component} from 'react';
import BoothArrangement from './booth-arrangement';
import {Stage} from 'vexpo-components';

/** @class HallLayout
  * A componet for positioning and scaling booths within the hall.
  */
export default class HallLayout extends Component {
  /** @method render
    * Renders the component.
    */
  render() {
    var stage = this.props.stage;
    var layers = [];
    for(var key in stage.layers) {
      var layer = stage.layers[key];
      layer.id = key;
      layers.push(layer);
    }
    stage.layers = layers.sort((a,b) => a.order - b.order);
    return (
      <div className="hall-wrapper">
        <Stage className="contain" {...stage}>
          <BoothArrangement
            dataURL={this.props.dataURL}
            boothList={this.props.boothList}
            width={stage.width}
            height={stage.height}
            />
        </Stage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/hall-editor/hall-layout.js